import nacl from 'tweetnacl-util';
import nacl$1 from 'tweetnacl';

/**
 * Error codes the wallet may return in {@link ConnectEventError}.
 *
 * @see [Connect event error codes (Connect spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/connect.md#connect-event-error-codes)
 */
var CONNECT_EVENT_ERROR_CODES;
(function (CONNECT_EVENT_ERROR_CODES) {
    /** Unexpected wallet-side failure. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    /** Request payload is malformed. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["BAD_REQUEST_ERROR"] = 1] = "BAD_REQUEST_ERROR";
    /** Wallet could not fetch the `tonconnect-manifest.json`. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["MANIFEST_NOT_FOUND_ERROR"] = 2] = "MANIFEST_NOT_FOUND_ERROR";
    /** Manifest was fetched but fails JSON / schema validation. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["MANIFEST_CONTENT_ERROR"] = 3] = "MANIFEST_CONTENT_ERROR";
    /** Wallet does not know the app / session. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["UNKNOWN_APP_ERROR"] = 100] = "UNKNOWN_APP_ERROR";
    /** User explicitly declined the connect prompt. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["USER_REJECTS_ERROR"] = 300] = "USER_REJECTS_ERROR";
    /** Wallet does not support the requested method. */
    CONNECT_EVENT_ERROR_CODES[CONNECT_EVENT_ERROR_CODES["METHOD_NOT_SUPPORTED"] = 400] = "METHOD_NOT_SUPPORTED";
})(CONNECT_EVENT_ERROR_CODES || (CONNECT_EVENT_ERROR_CODES = {}));
/**
 * Per-item error codes returned inside a {@link ConnectItemReplyError}.
 *
 * @see [Connect item error codes (Connect spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/connect.md#connect-item-error-codes)
 */
var CONNECT_ITEM_ERROR_CODES;
(function (CONNECT_ITEM_ERROR_CODES) {
    /** Unexpected wallet-side failure. */
    CONNECT_ITEM_ERROR_CODES[CONNECT_ITEM_ERROR_CODES["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    /** Wallet does not support this connect item. */
    CONNECT_ITEM_ERROR_CODES[CONNECT_ITEM_ERROR_CODES["METHOD_NOT_SUPPORTED"] = 400] = "METHOD_NOT_SUPPORTED";
})(CONNECT_ITEM_ERROR_CODES || (CONNECT_ITEM_ERROR_CODES = {}));

/**
 * Error codes the wallet may return from `sendTransaction`.
 *
 * @see [`sendTransaction` errors (RPC spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/rpc.md#sendtransaction)
 */
var SEND_TRANSACTION_ERROR_CODES;
(function (SEND_TRANSACTION_ERROR_CODES) {
    /** Unexpected wallet-side failure. */
    SEND_TRANSACTION_ERROR_CODES[SEND_TRANSACTION_ERROR_CODES["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    /** Request payload is malformed. */
    SEND_TRANSACTION_ERROR_CODES[SEND_TRANSACTION_ERROR_CODES["BAD_REQUEST_ERROR"] = 1] = "BAD_REQUEST_ERROR";
    /** Wallet does not know the dApp / session. */
    SEND_TRANSACTION_ERROR_CODES[SEND_TRANSACTION_ERROR_CODES["UNKNOWN_APP_ERROR"] = 100] = "UNKNOWN_APP_ERROR";
    /** User explicitly declined the transaction. */
    SEND_TRANSACTION_ERROR_CODES[SEND_TRANSACTION_ERROR_CODES["USER_REJECTS_ERROR"] = 300] = "USER_REJECTS_ERROR";
    /** Wallet does not support the method. */
    SEND_TRANSACTION_ERROR_CODES[SEND_TRANSACTION_ERROR_CODES["METHOD_NOT_SUPPORTED"] = 400] = "METHOD_NOT_SUPPORTED";
})(SEND_TRANSACTION_ERROR_CODES || (SEND_TRANSACTION_ERROR_CODES = {}));

/**
 * Error codes the wallet may return from `signData`.
 *
 * @see [`signData` errors (RPC spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/rpc.md#signdata)
 */
var SIGN_DATA_ERROR_CODES;
(function (SIGN_DATA_ERROR_CODES) {
    /** Unexpected wallet-side failure. */
    SIGN_DATA_ERROR_CODES[SIGN_DATA_ERROR_CODES["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    /** Invalid request payload. */
    SIGN_DATA_ERROR_CODES[SIGN_DATA_ERROR_CODES["BAD_REQUEST_ERROR"] = 1] = "BAD_REQUEST_ERROR";
    /** Wallet does not know the dApp / session. */
    SIGN_DATA_ERROR_CODES[SIGN_DATA_ERROR_CODES["UNKNOWN_APP_ERROR"] = 100] = "UNKNOWN_APP_ERROR";
    /** User explicitly declined. */
    SIGN_DATA_ERROR_CODES[SIGN_DATA_ERROR_CODES["USER_REJECTS_ERROR"] = 300] = "USER_REJECTS_ERROR";
    /** Wallet does not support `signData` method or the requested `type`. */
    SIGN_DATA_ERROR_CODES[SIGN_DATA_ERROR_CODES["METHOD_NOT_SUPPORTED"] = 400] = "METHOD_NOT_SUPPORTED";
})(SIGN_DATA_ERROR_CODES || (SIGN_DATA_ERROR_CODES = {}));

/**
 * Error codes the wallet may return from `disconnect`.

 * @see [`disconnect` errors (RPC spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/rpc.md#disconnect)
 */
var DISCONNECT_ERROR_CODES;
(function (DISCONNECT_ERROR_CODES) {
    DISCONNECT_ERROR_CODES[DISCONNECT_ERROR_CODES["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    DISCONNECT_ERROR_CODES[DISCONNECT_ERROR_CODES["BAD_REQUEST_ERROR"] = 1] = "BAD_REQUEST_ERROR";
    DISCONNECT_ERROR_CODES[DISCONNECT_ERROR_CODES["UNKNOWN_APP_ERROR"] = 100] = "UNKNOWN_APP_ERROR";
    DISCONNECT_ERROR_CODES[DISCONNECT_ERROR_CODES["METHOD_NOT_SUPPORTED"] = 400] = "METHOD_NOT_SUPPORTED";
})(DISCONNECT_ERROR_CODES || (DISCONNECT_ERROR_CODES = {}));

/**
 * Error codes the wallet may return from `signMessage`.
 *
 * @see [`signMessage` errors (RPC spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/rpc.md#signmessage)
 */
var SIGN_MESSAGE_ERROR_CODES;
(function (SIGN_MESSAGE_ERROR_CODES) {
    /** Unexpected wallet-side failure. */
    SIGN_MESSAGE_ERROR_CODES[SIGN_MESSAGE_ERROR_CODES["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    /** Invalid request payload. */
    SIGN_MESSAGE_ERROR_CODES[SIGN_MESSAGE_ERROR_CODES["BAD_REQUEST_ERROR"] = 1] = "BAD_REQUEST_ERROR";
    /** Wallet does not know the dApp / session. */
    SIGN_MESSAGE_ERROR_CODES[SIGN_MESSAGE_ERROR_CODES["UNKNOWN_APP_ERROR"] = 100] = "UNKNOWN_APP_ERROR";
    /** User explicitly declined. */
    SIGN_MESSAGE_ERROR_CODES[SIGN_MESSAGE_ERROR_CODES["USER_REJECTS_ERROR"] = 300] = "USER_REJECTS_ERROR";
    /** Wallet does not support `signMessage`. */
    SIGN_MESSAGE_ERROR_CODES[SIGN_MESSAGE_ERROR_CODES["METHOD_NOT_SUPPORTED"] = 400] = "METHOD_NOT_SUPPORTED";
})(SIGN_MESSAGE_ERROR_CODES || (SIGN_MESSAGE_ERROR_CODES = {}));

/**
 * Two baseline TON network IDs.
 */
var CHAIN;
(function (CHAIN) {
    CHAIN["MAINNET"] = "-239";
    CHAIN["TESTNET"] = "-3";
})(CHAIN || (CHAIN = {}));

function encodeUint8Array(value, urlSafe) {
    const encoded = nacl.encodeBase64(value);
    if (!urlSafe) {
        return encoded;
    }
    return encodeURIComponent(encoded);
}
function decodeToUint8Array(value, urlSafe) {
    if (urlSafe) {
        value = decodeURIComponent(value);
    }
    return nacl.decodeBase64(value);
}
function encode(value, urlSafe = false) {
    let uint8Array;
    if (value instanceof Uint8Array) {
        uint8Array = value;
    }
    else {
        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        uint8Array = nacl.decodeUTF8(value);
    }
    return encodeUint8Array(uint8Array, urlSafe);
}
function decode(value, urlSafe = false) {
    const decodedUint8Array = decodeToUint8Array(value, urlSafe);
    return {
        toString() {
            return nacl.encodeUTF8(decodedUint8Array);
        },
        toObject() {
            try {
                return JSON.parse(nacl.encodeUTF8(decodedUint8Array));
            }
            catch (e) {
                return null;
            }
        },
        toUint8Array() {
            return decodedUint8Array;
        }
    };
}
/**
 * UTF-8 base64 codec used by `@tonconnect/protocol`. Wraps the NaCl
 * helpers with optional URL-safe encoding and a typed decoder that can
 * yield a string, an object (JSON-parsed), or the raw byte array.
 *
 * @example
 * ```ts
 * import { Base64 } from '@tonconnect/protocol';
 *
 * const encoded = Base64.encode({ hello: 'world' });
 * const obj = Base64.decode(encoded).toObject<{ hello: string }>();
 * const bin = Base64.decode(Base64.encode('Hello')).toUint8Array();
 * ```
 */
const Base64 = {
    encode,
    decode
};

// ────────────────────────────────────────────────────────────────────────────
//  Helpers
// ────────────────────────────────────────────────────────────────────────────
function fromBase64Url(base64url) {
    const padded = base64url.length + ((4 - (base64url.length % 4)) % 4);
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/').padEnd(padded, '=');
    return Base64.decode(base64).toString();
}
function expandMessage(w) {
    const msg = { address: w.a, amount: w.am };
    if (w.p !== undefined) {
        msg.payload = w.p;
    }
    if (w.si !== undefined) {
        msg.stateInit = w.si;
    }
    if (w.ec !== undefined) {
        msg.extra_currency = w.ec;
    }
    return msg;
}
function expandItem(w) {
    switch (w.t) {
        case 'ton': {
            const item = { type: 'ton', address: w.a, amount: w.am };
            if (w.p !== undefined) {
                item.payload = w.p;
            }
            if (w.si !== undefined) {
                item.stateInit = w.si;
            }
            if (w.ec !== undefined) {
                item.extra_currency = w.ec;
            }
            return item;
        }
        case 'jetton': {
            const item = {
                type: 'jetton',
                master: w.ma,
                destination: w.d,
                amount: w.am
            };
            if (w.aa !== undefined) {
                item.attachAmount = w.aa;
            }
            if (w.rd !== undefined) {
                item.responseDestination = w.rd;
            }
            if (w.cp !== undefined) {
                item.customPayload = w.cp;
            }
            if (w.fa !== undefined) {
                item.forwardAmount = w.fa;
            }
            if (w.fp !== undefined) {
                item.forwardPayload = w.fp;
            }
            if (w.qi !== undefined) {
                item.queryId = w.qi;
            }
            return item;
        }
        case 'nft': {
            const item = {
                type: 'nft',
                nftAddress: w.na,
                newOwner: w.no
            };
            if (w.aa !== undefined) {
                item.attachAmount = w.aa;
            }
            if (w.rd !== undefined) {
                item.responseDestination = w.rd;
            }
            if (w.cp !== undefined) {
                item.customPayload = w.cp;
            }
            if (w.fa !== undefined) {
                item.forwardAmount = w.fa;
            }
            if (w.fp !== undefined) {
                item.forwardPayload = w.fp;
            }
            if (w.qi !== undefined) {
                item.queryId = w.qi;
            }
            return item;
        }
    }
}
function expandTransactionBody(wire) {
    const payload = {};
    if (wire.vu !== undefined) {
        payload.valid_until = wire.vu;
    }
    if (wire.n !== undefined) {
        payload.network = wire.n;
    }
    if (wire.f !== undefined) {
        payload.from = wire.f;
    }
    if (wire.ms) {
        payload.messages = wire.ms.map(expandMessage);
    }
    if (wire.i) {
        payload.items = wire.i.map(expandItem);
    }
    return payload;
}
function expandSignDataBody(wire) {
    const payload = {};
    if (wire.n !== undefined) {
        payload.network = wire.n;
    }
    if (wire.f !== undefined) {
        payload.from = wire.f;
    }
    switch (wire.t) {
        case 'text':
            payload.type = 'text';
            payload.text = wire.tx;
            break;
        case 'binary':
            payload.type = 'binary';
            payload.bytes = wire.b;
            break;
        case 'cell':
            payload.type = 'cell';
            payload.schema = wire.s;
            payload.cell = wire.c;
            break;
    }
    return payload;
}
/**
 * Decode a compact {@link WireEmbeddedRequest} back to the standard JSON-RPC
 * `AppRequest`-shaped `{ method, params: [JSON-string] }`.
 */
function decodeWireEmbeddedRequest(wire) {
    switch (wire.m) {
        case 'st':
            return {
                method: 'sendTransaction',
                params: [JSON.stringify(expandTransactionBody(wire))]
            };
        case 'sm':
            return {
                method: 'signMessage',
                params: [JSON.stringify(expandTransactionBody(wire))]
            };
        case 'sd':
            return {
                method: 'signData',
                params: [JSON.stringify(expandSignDataBody(wire))]
            };
    }
}
/**
 * Decode the `e` URL parameter and return `{ method, params: [string] }` —
 * the same shape as a bridge `AppRequest` (without `id`).
 *
 * The `e` value is `base64url(JSON.stringify(WireEmbeddedRequest))`.
 */
function decodeEmbeddedRequestParam(reqParam) {
    const json = fromBase64Url(reqParam);
    const wire = JSON.parse(json);
    return decodeWireEmbeddedRequest(wire);
}

/** Concatenate two byte arrays into a new `Uint8Array`. */
function concatUint8Arrays(buffer1, buffer2) {
    const mergedArray = new Uint8Array(buffer1.length + buffer2.length);
    mergedArray.set(buffer1);
    mergedArray.set(buffer2, buffer1.length);
    return mergedArray;
}
/**
 * Split `array` at `index` and return the two halves as fresh
 * `Uint8Array`s.
 */
function splitToUint8Arrays(array, index) {
    if (index >= array.length) {
        throw new Error('Index is out of buffer');
    }
    const subArray1 = array.slice(0, index);
    const subArray2 = array.slice(index);
    return [subArray1, subArray2];
}
/** Hex-encode a byte array, lowercase, no `0x` prefix. */
function toHexString(byteArray) {
    let hexString = '';
    byteArray.forEach(byte => {
        hexString += ('0' + (byte & 0xff).toString(16)).slice(-2);
    });
    return hexString;
}
/**
 * Inverse of {@link toHexString}. Throws when `hexString` has an odd length.
 */
function hexToByteArray(hexString) {
    if (hexString.length % 2 !== 0) {
        throw new Error(`Cannot convert ${hexString} to bytesArray`);
    }
    const result = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
        result[i / 2] = parseInt(hexString.slice(i, i + 2), 16);
    }
    return result;
}

/**
 * `true` when running inside Node.js (detected via `process.versions.node`).
 */
function isNode() {
    return (typeof process !== 'undefined' && process.versions != null && process.versions.node != null);
}

/**
 * Implements the TON Connect session-encryption protocol on top of NaCl's
 * `crypto_box`.
 *
 * The protocol is symmetric: each side encrypts the messages it sends and
 * decrypts the messages it receives. On the dApp side that means encrypting
 * outgoing {@link AppMessage} and decrypting incoming {@link WalletMessage};
 * the wallet does the reverse.
 *
 * @example
 * ```ts
 * import { SessionCrypto, Base64, hexToByteArray } from '@tonconnect/protocol';
 *
 * // Generate a fresh session
 * const session = new SessionCrypto();
 * const myClientId = session.sessionId;  // hex public key (sent to the peer)
 *
 * // Encrypt an outgoing message for the peer
 * const ciphertext = session.encrypt(
 *     JSON.stringify(message),
 *     hexToByteArray(peerClientId)
 * );
 *
 * // Decrypt an incoming message from the peer
 * const plaintext = session.decrypt(
 *     Base64.decode(bridgeMessage.message).toUint8Array(),
 *     hexToByteArray(bridgeMessage.from)
 * );
 * ```
 *
 * @see [Session protocol (Session spec)](https://github.com/ton-blockchain/ton-connect/blob/main/spec/session.md)
 */
class SessionCrypto {
    /**
     * Reuse an existing {@link KeyPair} (resuming a session) or generate a
     * fresh one (`crypto_box.keyPair()`) when omitted.
     */
    constructor(keyPair) {
        this.nonceLength = 24;
        this.keyPair = keyPair ? this.createKeypairFromString(keyPair) : this.createKeypair();
        this.sessionId = toHexString(this.keyPair.publicKey);
    }
    createKeypair() {
        return nacl$1.box.keyPair();
    }
    createKeypairFromString(keyPair) {
        return {
            publicKey: hexToByteArray(keyPair.publicKey),
            secretKey: hexToByteArray(keyPair.secretKey)
        };
    }
    createNonce() {
        return nacl$1.randomBytes(this.nonceLength);
    }
    /**
     * Encrypt `message` for `receiverPublicKey` using a fresh 24-byte random
     * nonce. Returns `nonce || ciphertext` as raw bytes; base64-encode this
     * value before placing it in the bridge `POST /message` body.
     */
    encrypt(message, receiverPublicKey) {
        const encodedMessage = new TextEncoder().encode(message);
        const nonce = this.createNonce();
        const encrypted = nacl$1.box(encodedMessage, nonce, receiverPublicKey, this.keyPair.secretKey);
        return concatUint8Arrays(nonce, encrypted);
    }
    /**
     * Decrypt the `nonce || ciphertext` blob received from the bridge.
     * Throws if `nacl.box.open` rejects the message — wrong key, truncated
     * input or tampered ciphertext.
     */
    decrypt(message, senderPublicKey) {
        const [nonce, internalMessage] = splitToUint8Arrays(message, this.nonceLength);
        const decrypted = nacl$1.box.open(internalMessage, nonce, senderPublicKey, this.keyPair.secretKey);
        if (!decrypted) {
            throw new Error(`Decryption error: \n message: ${message.toString()} \n sender pubkey: ${senderPublicKey.toString()} \n keypair pubkey: ${this.keyPair.publicKey.toString()} \n keypair secretkey: ${this.keyPair.secretKey.toString()}`);
        }
        return new TextDecoder().decode(decrypted);
    }
    /**
     * Export the underlying keypair as a {@link KeyPair} of hex strings.
     * Persist this in dApp / wallet storage to resume the session later.
     */
    stringifyKeypair() {
        return {
            publicKey: toHexString(this.keyPair.publicKey),
            secretKey: toHexString(this.keyPair.secretKey)
        };
    }
}

export { Base64, CHAIN, CONNECT_EVENT_ERROR_CODES, CONNECT_ITEM_ERROR_CODES, DISCONNECT_ERROR_CODES, SEND_TRANSACTION_ERROR_CODES, SIGN_DATA_ERROR_CODES, SIGN_MESSAGE_ERROR_CODES, SessionCrypto, concatUint8Arrays, decodeEmbeddedRequestParam, decodeWireEmbeddedRequest, hexToByteArray, isNode, splitToUint8Arrays, toHexString };
//# sourceMappingURL=index.mjs.map
